export enum OrderStatusEnum {
  PURCHASED = 'purchased',
  SHIPPED = 'shipped',
  OUT_OF_STOCK = 'out_of_stock',
  THIRD_PARTY = 'third_party',
  CANCELLED = 'cancelled',
}
